import { Image, StyleSheet, View } from 'react-native';
import Svg, { Line, Path } from 'react-native-svg';
import { AppText } from '../ui/AppText';
import { tokens } from '../../theme/tokens';

type OriginalDiagramViewerProps = {
  statement: string;
  assetRef: string;
  fixtureId: string;
  imageUri?: string | null;
  compact?: boolean;
};

export function OriginalDiagramViewer({ statement, assetRef, fixtureId, imageUri = null, compact = false }: OriginalDiagramViewerProps) {
  return (
    <View
      accessibilityLabel={`原题图证据 ${fixtureId}，不可变 assetRef：${assetRef}`}
      accessibilityRole="image"
      style={[styles.card, compact ? styles.compactCard : null]}
    >
      <View style={styles.titleRow}>
        <AppText variant="body" weight="bold">原题图</AppText>
        <View style={styles.evidenceBadge}>
          <AppText variant="caption" weight="bold" style={styles.evidenceText}>事实依据</AppText>
        </View>
      </View>
      <AppText variant="caption" tone="muted" style={styles.statement}>{statement}</AppText>
      {imageUri ? (
        <Image source={{ uri: imageUri }} resizeMode="contain" style={[styles.originalImage, compact ? styles.compactImage : null]} />
      ) : (
        <Svg width="100%" height={compact ? 138 : 188} viewBox="0 0 320 188">
          <Line x1="38" y1="122" x2="286" y2="122" stroke="#897C70" strokeWidth="2" />
          <Line x1="160" y1="32" x2="160" y2="166" stroke="#897C70" strokeWidth="2" />
          <Path d="M58 54 L110 112 L160 142 L210 112 L270 48" fill="none" stroke="#897C70" strokeWidth="2.5" />
        </Svg>
      )}
      <AppText variant="caption" tone="muted">可双指缩放 · 可复位 · 不自动补齐原图像素</AppText>
      <AppText variant="caption" tone="muted" numberOfLines={1}>assetRef: {assetRef}</AppText>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.sm,
    borderRadius: tokens.radius.md,
    borderWidth: tokens.border.width,
    borderColor: tokens.colors.border,
    padding: tokens.spacing.lg,
    backgroundColor: tokens.colors.surfaceMuted,
  },
  compactCard: {
    padding: tokens.spacing.md,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  evidenceBadge: {
    borderRadius: tokens.radius.full,
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.xs,
    backgroundColor: tokens.colors.successSoft,
  },
  evidenceText: {
    color: tokens.colors.success,
  },
  statement: {
    lineHeight: tokens.lineHeight.md,
  },
  originalImage: {
    width: '100%',
    height: 188,
    borderRadius: tokens.radius.sm,
    backgroundColor: tokens.colors.surface,
  },
  compactImage: {
    height: 138,
  },
});
